import { toast } from 'react-toastify';
import { Box, Button, ButtonGroup, Container, Stack, TextField, Typography, ToggleButton, ToggleButtonGroup, MenuItem } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import axios from 'axios';
import FileBase from 'react-file-base64';
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { MdCloudUpload } from 'react-icons/md';
import { API_URL } from '../../api';
import QuillEditor from '../../utils/QuillEditor';
import Cookies from 'universal-cookie';
import showLoader from 'src/components/loader';

import { DateBox } from 'devextreme-react/date-box';
import CourseDatesEditor, { emptyDateRow, datesProblem } from '../../components/CourseDatesEditor';
const cookies = new Cookies();

function NewCourse() {
  const classes = useStyles();
  const navigate = useNavigate();
  const dateBoxRef = useRef(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [longDescription, setLongDescription] = useState('');
  const [date, setDate] = useState(null);
  const [time, setTime] = useState('');
  const [cost, setCost] = useState(null);
  const [location, setLocation] = useState('');
  const [bookinglink, setBookinglink] = useState('');
  const [subjectStatus, setSubjectStatus] = useState(localStorage.getItem("subject") !== null && localStorage.getItem("subject") !== undefined ? localStorage.getItem("subject") : "english")
  const [subject, setSubject] = useState('');
  const [level, setLevel] = useState('');
  const [tag, setTag] = useState('');
  const [status, setStatus] = useState('active');
  const [costtype, setCostType] = useState('Per lesson');
  const [sold, setSold] = useState('false');
  const [multiDate, setMultiDate] = useState(false);
  const [dateRows, setDateRows] = useState([]);

  const [img, setImg] = useState('');

    const handleClick = () => {
    // Always open calendar, even if value exists
    dateBoxRef.current?.instance?.open();
  };


  const createCourse = async (title, longDescription, date, time, cost, location, bookinglink, img, subjectStatus, subject, level, tag, status, costtype, sold, dates) => {

    showLoader(true);
    await axios
      .post(
        `${API_URL}/api/courses`,
        { title, longDescription, date, time, cost, location, bookinglink, img, subjectStatus, subject, level, tag, status, costtype, sold, dates },
        {
          headers: {
            Authorization: cookies.get('TOKEN'),
          },
        }
      )
      .then((res) => {
        navigate('/course');
      })
      .catch((err) => console.log(err));

    showLoader(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    /* validate first */
    if (!status) {
      toast.error('Status is required');
      return;
    }
    if (title.length === 0) {
      toast.error('Title is required');
      return;
    }
    if (tag.length === 0) {
      toast.error('Tag is required');
      return;
    }

    if (subject.length === 0) {
      toast.error('Subject is required');
      return;
    }
    if (level.length === 0) {
      toast.error('Level is required');
      return;
    }

    if (multiDate) {
      const problem = datesProblem(dateRows);
      if (problem) {
        toast.error(problem);
        return;
      }
    } else if (date === null) {
      toast.error('Date is required');
      return;
    }

    if (time.length === 0) {
      toast.error('Time is required');
      return;
    }

    if (cost.length === 0) {
      toast.error('Cost is required');
      return;
    }

    if (costtype.length === 0) {
      toast.error('Cost Type is required');
      return;
    }

    // if (description.length === 0) {
    //   toast.error('Front description is required');
    //   return;
    // }
    if (longDescription.length === 0) {
      toast.error('Description is required');
      return;
    }
    if (img.length === 0) {
      toast.error('Image is required');
      return;
    }

    const dates = multiDate ? dateRows : [];
    const firstDate = multiDate ? [...dateRows].sort((a, b) => a.date.localeCompare(b.date))[0].date : date;
    createCourse(title, longDescription, firstDate, time, cost, location, bookinglink, img, subjectStatus, subject, level, tag, status, costtype, sold, dates);


  };

  const back = (e) => {
    e.preventDefault();
    navigate('/course');
  };

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Inter', fontWeight: '600' }}>
          New Course
        </Typography>
      </Stack>
      <Box
        component="form"
        className={classes.form}
        onSubmit={handleSubmit}
        sx={{
          '& > :not(style)': { m: 1, width: '' },
        }}
      >

        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          label="Title"
          type="text"
          margin="normal"
        />

        {/* Tag Dropdown */}
        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={tag}
          onChange={(e) => setTag(e.target.value)}
          label="Tag"
          select
          margin="normal"
        >
          <MenuItem value="Reading Club">Reading Club</MenuItem>
          <MenuItem value="KS3 English">KS3 English</MenuItem>
          <MenuItem value="GCSE English Language">GCSE English Language</MenuItem>
          <MenuItem value="GCSE English Literature">GCSE English Literature</MenuItem>
        </TextField>

        {/* Subject Dropdown */}
        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          label="Subject"
          select
          margin="normal"
        >
          <MenuItem value="Reading Club">Reading Club</MenuItem>
          <MenuItem value="KS3 English">KS3 English</MenuItem>
          <MenuItem value="GCSE English Language">GCSE English Language</MenuItem>
          <MenuItem value="GCSE English Literature">GCSE English Literature</MenuItem>
        </TextField>

        {/* Level Dropdown */}
        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={level}
          onChange={(e) => setLevel(e.target.value)}
          label="Level"
          select
          margin="normal"
        >
          <MenuItem value="KS1 (5-7 yrs)">KS1 (5-7 yrs)</MenuItem>
          <MenuItem value="KS2 (7-11 yrs)">KS2 (7-11 yrs)</MenuItem>
          <MenuItem value="KS3 (11-14 yrs)">KS3 (11-14 yrs)</MenuItem>
          <MenuItem value="GCSE (14-16 yrs)">GCSE (14-16 yrs)</MenuItem>
        </TextField>

 <div style={{ width: "100%" }}>
      <label style={{ fontFamily: 'Inter', display: 'flex', alignItems: 'center', gap: '5px' }}>
        <input
          type="checkbox"
          checked={multiDate}
          onChange={(e) => {
            setMultiDate(e.target.checked);
            if (e.target.checked && dateRows.length === 0) setDateRows([emptyDateRow(), emptyDateRow()]);
          }}
        />
        Offer this course on several dates
      </label>
    </div>

    {multiDate ? (
      <CourseDatesEditor rows={dateRows} onChange={setDateRows} />
    ) : (
 <div style={{ width: "45%" }} onClick={handleClick}>
      <DateBox
        ref={dateBoxRef}
        value={date}
        onValueChanged={(e) => setDate(e.value)}
        type="date"
        displayFormat="dd/MM/yyyy"
        placeholder="Select course date"
        className="date-field"
        openOnFieldClick={true}
      />
    </div>
    )}

        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={time}
          onChange={(e) => setTime(e.target.value)}
          label="Time"
          type="text"
          margin="normal"
        />
       {/*   <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={cost}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) { // only digits allowed
              setCost(value);
            }
          }}
          label="Cost"
          type="text"
          margin="normal"
        /> */}

            <TextField
               className={classes.formFields}
               sx={{ fontFamily: 'Inter', fontWeight: '400' }}
               value={cost}
                   onChange={(e) => setCost(e.target.value)}
               label="Cost"
               type="text"
               margin="normal"
             /> 

        {/* Cost Type Dropdown */}
        {/* <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={costtype}
          onChange={(e) => setCostType(e.target.value)}
          label="Cost Type"
          select
          margin="normal"
        >
          <MenuItem value="Per lesson">Per lesson</MenuItem>
          <MenuItem value="Per session">Per session</MenuItem>
          <MenuItem value="Per day">Per day</MenuItem>
          <MenuItem value="Complete course">Complete course</MenuItem>
        </TextField> */}

        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          label="Location"
          type="text"
          margin="normal"
        />
        <TextField
          className={classes.formFields}
          sx={{ fontFamily: 'Inter', fontWeight: '400' }}
          value={bookinglink}
          onChange={(e) => setBookinglink(e.target.value)}
          label="Booking Link"
          type="text"
          margin="normal"
        />

        <div className={classes.formFields}>
          <label style={{ fontFamily: 'Inter', fontWeight: '600', display: 'block', marginBottom: '10px' }}>
            Course Status
          </label>
          <div style={{ display: 'flex', gap: '20px' }}>
            <label style={{ fontFamily: 'Inter', display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="radio"
                value="active"
                checked={status === 'active'}
                onChange={(e) => setStatus(e.target.value)}
              />
              Active
            </label>
            <label style={{ fontFamily: 'Inter', display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="radio"
                value="inactive"
                checked={status === 'inactive'}
                onChange={(e) => setStatus(e.target.value)}
              />
              Inactive
            </label>
            <label style={{ fontFamily: 'Inter', display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="radio"
                value="draft"
                checked={status === 'draft'}
                onChange={(e) => setStatus(e.target.value)} // ✅ setStatus use karein
              />
              Draft
            </label>
          </div>
        </div>

        <div className={classes.formFields}>
          <label
            style={{ fontFamily: 'Inter', fontWeight: '600', display: 'block', marginBottom: '10px' }}
          >
            Is sold out
          </label>
          <div style={{ display: 'flex', gap: '20px' }}>
            <label style={{ fontFamily: 'Inter', display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="checkbox"
                checked={sold === 'true'}
                onChange={(e) => setSold(e.target.checked ? 'true' : 'false')} // update state based on checked
              />
              Sold
            </label>
          </div>
        </div>



        {/* <div className={classes.textEditor}>
          <p style={{ margin: '5px 0px', fontFamily: 'Inter' }}>Front Description</p>
          <QuillEditor value={description} setDesc={setDescription} />
        </div> */}

        <div className={classes.textEditor}>
          <p style={{ margin: '5px 0px', fontFamily: 'Inter' }}>Description</p>
          <QuillEditor value={longDescription} setDesc={setLongDescription} />
        </div>

        <div
          className={classes.formFields}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: '2px dashed #1475cf',
            borderRadius: '10px',
            height: '400px',
            width: '550px',
          }}
        >
          {img ? (
            <img src={img} width="200px" height="200px" alt="preview" />
          ) : (
            <MdCloudUpload color="#1475cf" size={60} />
          )}
          <div>
            <FileBase
              type="file"
              id="images"
              accept="image/*"
              required
              multiple={false}
              onDone={({ base64 }) => {
                console.log(base64);
                setImg(base64);
              }}
            />
          </div>

          {/* Helper Text */}
          <p style={{ marginTop: "0px", fontSize: "13px", color: "#555", textAlign: "center" }}>
            Upload an image (440×440 recommended for best quality). Larger images are fine — we’ll resize them for thumbnails and display them as 440×440 on the detail page.
          </p>
        </div>


        <ButtonGroup className={classes.buttons} aria-label="outlined primary button group">
          <Button onClick={(e) => back(e)} style={{ fontFamily: 'Inter', minWidth: '90px' }}>
            Back
          </Button>
          <Button variant="contained" type="submit" style={{ fontFamily: 'Inter', minWidth: '90px' }}>
            Publish
          </Button>
        </ButtonGroup>
      </Box>
    </Container>
  );
}

export default NewCourse;

const useStyles = makeStyles((theme) =>
  createStyles({
    form: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formFields: {
      flexBasis: '45%',
      margin: '10px',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '90%',
      },
    },
    formFieldsSelect: {
      flexBasis: '91%',
      margin: '10px',

      [theme.breakpoints.down('sm')]: {
        flexBasis: '91%',
      },
    },
    textEditor: {
      flexBasis: '91.5%',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '90%',
      },
    },
    buttons: {
      flexBasis: '91.5%',
      justifyContent: 'flex-end',
    },
  })
);
